import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRecordedTrainings = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3 6C3 4.89543 3.89543 4 5 4H27C28.1046 4 29 4.89543 29 6V8C29 9.10457 28.1046 10 27 10V22H28C28.5523 22 29 22.4477 29 23C29 23.5523 28.5523 24 28 24H17V26.1707C18.1652 26.5825 19 27.6938 19 29C19 30.6569 17.6569 32 16 32C14.3431 32 13 30.6569 13 29C13 27.6938 13.8348 26.5825 15 26.1707V24H4C3.44772 24 3 23.5523 3 23C3 22.4477 3.44772 22 4 22H5V10C3.89543 10 3 9.10457 3 8V6ZM7 22H25V10H7V22ZM27 8H5V6H27V8ZM15 29C15 28.4477 15.4477 28 16 28C16.5523 28 17 28.4477 17 29C17 29.5523 16.5523 30 16 30C15.4477 30 15 29.5523 15 29Z"
	})
});
export default SvgRecordedTrainings;
